<template>
  <div class="help-page-layout w-100">
    <div class="back-btn mb-2" @click="$router.back()">{{ $lang.messages.back }}</div>
    <div class="text-center mb-3">
      <img alt="logo" src="./../assets/img/logo-new.svg" class="logo">
    </div>
    <div class="block-popup help-page-container">
      <div class="content-block-title">{{showPas ? $lang.messages.app.recover.passcode_is : $lang.messages.app.recover.recover_passcode}}</div>
      <div v-if="!showPas" class="mb-1">{{ $lang.messages.app.recover.enter_email }}</div>
      <div v-if="this.showPas" class="password-show text-huge text-bold">
        {{ accountPassword || $lang.messages.app.recover.dont_have_passcode }}
      </div>
      <div v-else>
        <input
            id="email"
            type="email"
            class="form-control -outline"
            v-model="enteredEmail"
            :placeholder="$lang.messages.kid.forgot.enter_email"
            @keyup.enter="showPassword"
        >
        <div class="form-error" v-if="errorInEmail">{{ $lang.messages.kid.forgot.forgot_error }}</div>
      </div>
      <div class="mt-2 flex-between">
        <button class="btn btn-link mr-1" :class="{'btn-main': showPas}" @click="screen='help'; showPas = false">{{showPas ? 'Ok' : 'Cancel'}}</button>
        <button class="btn btn-main" v-if="!showPas" @click="showPassword">{{ $lang.messages.submit }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState} from "vuex";

export default {
  name: "Recover",
  data: function () {
    return {
      enteredEmail: '',
      errorInEmail: false,
      showPas: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      accountPassword: state => state.accountData.password,
    }),
  },
  methods: {
    showPassword () {
      this.errorInEmail = false
      if(this.user.email === this.enteredEmail){
        this.showPas = true
      } else {
        this.errorInEmail = true
      }
    },
  }
}
</script>

<style scoped>

</style>